export default "skymp5-front/f52adb1983ad2b6fb0a30f8e9032c125.mp3";